var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      attrs: { title: _vm.$t("professionalPrevalidated.title") },
      on: { shown: _vm.resetForm },
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("p", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("professionalPrevalidated.description"))
            }
          }),
          _vm._v(" "),
          _c("base-input", {
            attrs: { placeholder: _vm.$t("professionalPrevalidated.email") },
            model: {
              value: _vm.email,
              callback: function($$v) {
                _vm.email = $$v
              },
              expression: "email"
            }
          }),
          _vm._v(" "),
          _c(
            "base-checkbox",
            {
              model: {
                value: _vm.termsAccepted,
                callback: function($$v) {
                  _vm.termsAccepted = $$v
                },
                expression: "termsAccepted"
              }
            },
            [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.$t("signupOH.accept-terms")) }
              })
            ]
          ),
          _vm._v(" "),
          _c("VueRecaptcha", {
            staticClass: "custom-recaptcha",
            attrs: { sitekey: _vm.siteKey, "load-recaptcha-script": true },
            on: {
              verify: function($event) {
                _vm.validCaptcha = true
              },
              error: function($event) {
                _vm.validCaptcha = false
              },
              expired: function($event) {
                _vm.validCaptcha = false
              }
            }
          }),
          _vm._v(" "),
          _c(
            "base-button",
            { staticClass: "mt-4", on: { click: _vm.sendForm } },
            [_vm._v(_vm._s(_vm.$t("send")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c2bf060", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c2bf060","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/search/ProfessionalPrevalidatedModal.vue
// module id = 3683
// module chunks = 11